<section [style.background-image]="bannerImage" class="hero-bg px-3 pt-1 pb-4 h-100">
  <div class="modal-header">
    <h1 class="modal-title text-6 text-white">Welcome to QuickBus</h1>
    <button (click)="closeDialog()" class="close" type="button"><span class="text-white">&times;</span></button>
  </div>
  <div class="modal-body">
    <p class="mt-0 mb-4 text-3 text-white line-height-3">
      {{data.text}}
    </p>
    <form [formGroup]="userInfoForm" class="form-row row">
      <!-- <h3 class="text-4 mb-3 mt-4">Enter your details</h3> -->
      <mat-form-field appearance="fill" class="col-12">
        <mat-label>First name</mat-label>
        <input type="text"
          aria-label="First name"
          matInput
          formControlName="firstName">
      </mat-form-field>
      <mat-form-field appearance="fill" class="col-12">
        <mat-label>Last name</mat-label>
        <input type="text"
          aria-label="Last name"
          matInput
          formControlName="lastName">
      </mat-form-field>
      <mat-form-field appearance="fill" class="col-12">
        <mat-label>Phone</mat-label>
        <input type="tel"
          aria-label="Phone"
          matInput
          formControlName="phone">
      </mat-form-field>
      <mat-form-field appearance="fill" class="col-12">
        <mat-label>Email</mat-label>
        <input type="text"
          aria-label="Email"
          matInput
          formControlName="email">
      </mat-form-field>
      <div class="col-12">
        <button (click)="onSubmit()" class="btn btn-secondary btn-lg btn-block" [disabled]="loading">Submit <mat-spinner diameter="22" *ngIf="loading"></mat-spinner></button>
      </div>
    </form>
  </div>
</section>